module.exports = __webpack_public_path__ + "img/turn_icon_1.45c484b3.png";